<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script lang="ts">
import { isObject } from 'lodash';
import { computed, defineComponent } from 'vue';
export default defineComponent({
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: 'svg-icon',
    },
    color: {
      type: String,
      default: '#ff0000',
    },
  },
  setup(props) {
    return {
      iconName: computed(() => `#icon-${props.iconClass}`),
      svgClass: computed(() => {
        if (props.className) {
          if (isObject(props.className)) {
            return Object.keys(props.className).reduce((str, key) => {
              return props.className[key] ? `${str} ${key}` : str;
            }, 'svg-icon');
          } else {
            return `svg-icon ${props.className}`;
          }
        }
        return 'svg-icon';
      }),
    };
  },
});
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  position: relative;
  fill: currentColor;
  vertical-align: -2px;
}
</style>
